function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
import { createLogger, DEBUG, stdSerializers } from 'browser-bunyan';
import { ConsoleFormattedStream } from "./ConsoleFormattedStream.js";
import serializeErr from "./serializeErr.js";
export var logger = createLogger({
  name: 'formative',
  serializers: _objectSpread(_objectSpread({}, stdSerializers), {}, {
    err: serializeErr
  }),
  streams: [{
    level: DEBUG,
    stream: new ConsoleFormattedStream()
  }]
});
if (typeof window !== 'undefined') {
  window.log = logger;
}
var _makeLogger = function makeLogger(impl) {
  return {
    child: function child(opts, simple) {
      return _makeLogger(impl.child(opts, simple));
    },
    debug: impl.debug.bind(impl),
    error: impl.error.bind(impl),
    fatal: impl.fatal.bind(impl),
    info: impl.info.bind(impl),
    level: impl.level.bind(impl),
    trace: impl.trace.bind(impl),
    warn: impl.warn.bind(impl)
  };
};
export default _makeLogger(logger);